export class SearchStudentByKeywordsRequest {
    firstName: string = "";
    lastName: string = "";
    dateOfBirth: string = "";
    ssn: string = "";
    pageSize: number = 0;
    pageNumber: number = 0;
    accessID: number = 0;
    accessLevel: number = 0;
    schoolYear: number = 0;
    schoolDistrict: number = 0;
    campusID: number = 0;
    userId?: string = "";
    campusName?: string = "";

    constructor(firstName: string, lastname: string, dateOfBirth: string, ssn: string, pageSize: number, pageNumber: number, accessID: number, accessLevel: number, schoolYear: number, schoolDistrict: number, campusID: number) {
        this.firstName = firstName;
        this.lastName = lastname;
        this.dateOfBirth = dateOfBirth;
        this.ssn = ssn;
        this.pageSize = pageSize;
        this.pageNumber = pageNumber;
        this.accessID = accessID;
        this.accessLevel = accessLevel;
        this.schoolYear = schoolYear;
        this.schoolDistrict = schoolDistrict;
        this.campusID = campusID;
    }
}